import plur from 'plur'

const TITLES = {
  NO_AGENTS: 'There are no agents',
  ALL_BUSY: 'All agents are busy',
  ALL_IDLE: 'All agents are idle',
}

export const calculateContent = (
  agentsNum: number | null | undefined = null,
  freeAgentsNum: number | null | undefined = null,
) => {
  let agentsLoad = 0
  let title =
    agentsNum == null || agentsNum === 0
      ? TITLES.NO_AGENTS
      : `There ${agentsNum > 1 ? 'are' : 'is'} ${agentsNum} ${plur('agent', agentsNum)}`

  if (agentsNum != null && freeAgentsNum != null) {
    const workingAgentsNum = agentsNum - freeAgentsNum

    if (workingAgentsNum > 0 || freeAgentsNum > 0) {
      // eslint-disable-next-line @typescript-eslint/no-magic-numbers
      agentsLoad = Math.round((workingAgentsNum * 100.0) / agentsNum)
    }

    if (agentsLoad < 0) {
      // eslint-disable-next-line @typescript-eslint/no-magic-numbers
      agentsLoad = 100
    }

    const idle = freeAgentsNum < 0 ? 0 : freeAgentsNum

    if (agentsNum === 0) {
      title = TITLES.NO_AGENTS
    } else if (idle === 0) {
      title = TITLES.ALL_BUSY
    } else if (idle === agentsNum) {
      title = TITLES.ALL_IDLE
    } else {
      title = `${workingAgentsNum + (workingAgentsNum > 1 ? ' builds are' : ' build is')} running, `
      title += `${idle + (idle > 1 ? ' agents are' : ' agent is')} idle`
    }
  }

  return {
    agentsLoad,
    title,
  }
}
